// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Criteria = t.struct({
    pin: t.String
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        pin: ''
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/pin-cross-reference/state/criteria.js